export var TimeSlotsModelSplitResultStatus;
(function (TimeSlotsModelSplitResultStatus) {
    /**
     * The run has started, but a request has not been made to python
     * for this split.
     */
    TimeSlotsModelSplitResultStatus["PENDING"] = "pending";
    /**
     * A request has been initiated to python for this split.
     *
     * Note: The split can get stuck at this status if the TS trigger times out.
     */
    TimeSlotsModelSplitResultStatus["STARTED"] = "started";
    /** The python request succeeded for this split. */
    TimeSlotsModelSplitResultStatus["SUCCESS"] = "success";
    /** The python request failed or some other error occured for this split. */
    TimeSlotsModelSplitResultStatus["FAILED"] = "failed";
})(TimeSlotsModelSplitResultStatus || (TimeSlotsModelSplitResultStatus = {}));
//# sourceMappingURL=timeSlots.js.map